import { getFullUrl } from 'hubspot-url-utils';
import { prefetchPage } from 'prefetcher/utils/prefetchPage';
import { ExperimentIdentifier } from '../experiments/ExperimentIdentifier';
import { getIsActiveAndAssignedToVariantAcq136 } from '../experiments/acq136/acq136Selectors';
import { setHublet, setIsNewUser, setNewPortalCreated } from '../store/app/action-creators';
import { fetchExperiments } from '../store/experiments/action-creators';
import { completeStepAction } from '../store/flow/action-creators';
import { getCurrentStep, getPostAccountCreationSteps } from '../store/flow/selectors';
import { Step } from '../views/Step';
import { setNewPortalId } from './setNewPortalId';
import { signupSuccessTracking } from './signupSuccessTracking';
export const handleSignupSuccess = (response, dispatch, getState) => {
  const state = getState();
  const {
    hubId,
    userCreated,
    region: hublet,
    creatorId
  } = response;
  const postAccountCreation = getPostAccountCreationSteps(state);
  const currentStep = getCurrentStep(state);
  const isAcq136Variant = getIsActiveAndAssignedToVariantAcq136(state);
  signupSuccessTracking(state, creatorId);
  setNewPortalId({
    hubId,
    hublet
  }, dispatch);
  dispatch(setHublet(hublet));
  dispatch(setNewPortalCreated());
  dispatch(setIsNewUser(userCreated));

  if (postAccountCreation.length >= 1 && postAccountCreation[0] !== Step.MobileAppPrompt) {
    dispatch(fetchExperiments({
      identifierPhase: ExperimentIdentifier.PortalId
    }));
  }

  prefetchPage('setup-guide-ui-prefetch', {
    url: getFullUrl('app', {
      hubletOverride: hublet
    })
  });

  if (currentStep === Step.HubletSelection && isAcq136Variant) {
    dispatch(completeStepAction({
      stepKey: Step.HubletSelection
    }));
  }
};